import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AssessmentAttributes, CheckoutType, StoresSlugEnum } from 'src/app/enums/assessment.enum';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  SERVER_URL = environment.SERVER_URL;
  private cartSubject = new BehaviorSubject<number>(this.getCartLengthFromLocalStorage());

  constructor(private http: HttpClient) {}

  // Expose the cart count as an observable
  addToCartSubject = this.cartSubject.asObservable();

  // Get cart items from localStorage
  private getCartLengthFromLocalStorage():number {
    let cartDetails = this.getCartDetailsFromLocalStorage();
    // Filter cart items for teacher assessments and exclude those from Learnings store
    cartDetails = cartDetails.filter((item:any) => item.checkoutType === CheckoutType.TEACHER_ASSESSMENT && item?.assessment?.storeDoc?.slug !== StoresSlugEnum.LEARNINGS);
    return cartDetails?.length;
  }

  // Update count
  updateCartCount(count: number) {
    this.cartSubject.next(count);
  }

  // Increment count
  incrementCart(count: number = 1) {
    const newCount = this.cartSubject.getValue() + count;
    this.updateCartCount(newCount);
  }

  // Decrement count
  decrementCart(count: number = 1) {
    let newCount = this.cartSubject.getValue() - count;
    if (newCount < 0) newCount = 0; // Prevent negative values
    this.updateCartCount(newCount);
  }

  // Refresh count from localStorage
  refreshCartCount() {
    const count = this.getCartLengthFromLocalStorage()
    this.updateCartCount(count);
  }

  // Retrieves cart details from localStorage 
  getCartDetailsFromLocalStorage(): any[] {
    const cart_details = JSON.parse(localStorage.getItem('cart_details') || "[]");
    return cart_details;
  }

  addToCart(assessment: any) {
    const assessmentDocId = assessment.assessment.assessmentDocId;

    let cart = this.getCartDetailsFromLocalStorage();
    const assessmentExists = cart.find( item => assessmentDocId == item.assessment.assessmentDocId);
    if(assessmentExists == undefined) {
      cart.push(assessment);
    }

    localStorage.setItem('cart_details', JSON.stringify(cart));
    this.refreshCartCount();
  }

  setCartDetailsInLocalStorage(cartDetails: any[]) {
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
  }

  removeCartItemsFormLocalStorage(assessmentIds:string[]){
    let cartDetails:any[] = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter(item => !assessmentIds.includes(item?.assessment?.assessmentDocId));
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
    this.refreshCartCount();
  }

  removeOlympiadsFromLocalStorage(){
    let cartDetails:any[] = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter(item => item?.assessment?.storeDoc?.slug !== StoresSlugEnum.OLYMPIADS);
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
    this.refreshCartCount();
  }
  
  applyCoupon(couponCode: string, subTotal: number, checkoutType: string, options: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}coupons/applyCoupon`;
    const checkoutAssessmentIds = options.checkoutAssessmentIds;
    return this.http.post(API_URL, {couponCode, subTotal, checkoutType, checkoutAssessmentIds}).pipe(
      map((res) => res)
    );
  }

  removeAssessmentWithOnlyLevelSelectionFromLocalStorage(){
    let cartDetails:any[] = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter(item => !item?.assessment?.attributes?.includes(AssessmentAttributes.LEVELS));
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
    this.refreshCartCount();
  }

  removeLmsCoursesFromLocalStorage(){
    let cartDetails:any[] = this.getCartDetailsFromLocalStorage();
    cartDetails = cartDetails.filter(item => item?.assessment?.storeDoc?.slug !== StoresSlugEnum.LEARNINGS);
    localStorage.setItem('cart_details', JSON.stringify(cartDetails));
    this.refreshCartCount();
  }

}
